import axios from "../axiosInstance"

export const getDropboxDocuments = async (dealId: number) => {
  try {
    const res = await axios.get(`/documents/dropbox/${dealId}`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch documents")
    }
    return data.documents
  } catch (error) {
    console.error("Error fetching documents:", error)
    throw error
  }
}

export const downloadDocument = async ({ dealId, name }: { dealId: number, name: string }) => {
  try {
    const res = await axios.post(`/documents/download`, {
      dealId,
      name,
    }, {
      responseType: "blob",
    })
    return res.data
  } catch (error) {
    console.error("Error downloading document:", error)
    throw error
  }
}

export const createExcelOpenToken = async (dealId: number, fileName: string): Promise<string> => {
  const res = await axios.post(`/documents/excel-token`, { dealId, fileName })
  if (!res.data.success) throw new Error("Failed to create Excel open token")
  return res.data.token
}

export const getDealFilesForManager = async (dealId: number): Promise<Array<{ name: string; date: string; type: string; link: string }>> => {
  const res = await axios.post(`/documents/manager`, { dealId })
  if (!res.data.success) throw new Error("Failed to fetch deal files")
  return res.data.documents
}

export const uploadDocuments = async ({ dealIdStr = "-1", documentType, files }: { dealIdStr?: string; documentType: string; files: File[] }) => {
  const formData = new FormData()
  files.forEach(file => formData.append("files", file))
  formData.append("dealId", dealIdStr)
  formData.append("documentType", documentType)

  try {
    const res = await axios.post(`/documents/upload/bulk`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to upload documents")
    }
    return data.documents
  } catch (error) {
    console.error("Error uploading documents:", error)
    throw error
  }
}
